<template>
  <v-container fluid class="d-flex flex-row">
    <v-navigation-drawer permanent expand-on-hover class="d-flex flex-shrink-0">
      <v-list dense nav>
        <v-list-item link :to="{ name: 'CoachingOnboardingSubscription', params: { coachId: coachId } }">
          <v-list-item-icon>
            <v-badge small color="pink" :content="coach ? coach.unresolvedChats : 0" :value="coach ? coach.unresolvedChats : 0">
              <v-icon>mdi-account-multiple</v-icon>
            </v-badge>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Clients</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="`/tasks/${coachId}`">
          <v-list-item-icon>
            <v-badge small color="navy" :content="coach ? coach.unresolvedTasks : 0" :value="coach ? coach.unresolvedTasks : 0">
              <v-icon>mdi-format-list-checks</v-icon>
            </v-badge>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Outstanding tasks</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{ name: 'CoachingManageSecondarySubscription' }">
          <v-list-item-icon>
            <v-icon>mdi-umbrella-beach</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Manage your leave</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{ name: 'History' }">
          <v-list-item-icon>
            <v-icon>mdi-clipboard-text-clock</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Past clients</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <router-view class="flex" />
  </v-container>
</template>

<script>
import { COACH_TASK_NUMBERS } from "@/constants/graphql/coach/coaching";

export default {
  name: "CoachingDashboardBase",
  props: {
    coachId: {
      type: [Number, String],
      required: true,
    },
  },
  apollo: {
    coach: {
      query: COACH_TASK_NUMBERS,
      variables() {
        return {
          id: this.coachId,
        };
      },
      fetchPolicy: "cache-and-network",
      update(data) {
        return data.coachTaskNumbers;
      },
    },
  },
};
</script>
